import api from './api'

const endpoints = {
  providers: `/v4/${process.env.VUE_APP_DEVICE}/scheduling/providers`,
  scheduleAppointment: `/v4/${process.env.VUE_APP_DEVICE}/scheduling/schedule-appointment`,
  getPcpsOnFile: `/v4/${process.env.VUE_APP_DEVICE}/scheduling/pcps-on-file`,
  getAppointments: `/v4/${process.env.VUE_APP_DEVICE}/scheduling/appointments`,
}

export const getProviders = (params) =>
  api()
    .url(endpoints.providers)
    .query(params)
    .get()

export const scheduleAppointment = (data) =>
  api()
    .url(endpoints.scheduleAppointment)
    .post(data)

export const getPcpsOnFile = () =>
  api()
    .url(endpoints.getPcpsOnFile)
    .get()

export const getAppointments = () =>
  api()
    .url(endpoints.getAppointments)
    .get()
